import React, { useEffect, useRef, useState } from 'react';
import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import useIsWidescreen from '@medflex/hooks/useIsWideScreen';
import InputField from '../InputField';
import { IconSearch } from '../Icons';
import ScrollableTabs from '../ScrollableTabs';

const AddressBookTitleBar = ({
  onSearchTermChanged,
  className,
  filter,
  onChangeFilter,
  tabs,
  title,
  searchInputPlaceholder,
}) => {
  const cn = useClassNames(
    () => [
      'w-full',
      'select-none',
      'bg-slate-50',
      'p-4',
      'pb-0',
      'flex',
      'flex-col',
      'space-y-2',
      'border-b',
      className,
    ],
    [className],
  );
  const [searchTerm, setSearchTerm] = useState('');
  const ref = useRef();
  const isWideScreen = useIsWidescreen();

  useEffect(() => {
    onSearchTermChanged(searchTerm);
  }, [searchTerm]);

  return (
    <div data-component="AddressBookTitleBar" className={cn}>
      {title && <h4 className="font-semibold text-slate-900 text-xl">{title}</h4>}
      <InputField
        type="search"
        autoFocus={isWideScreen}
        className="flex-shrink-0 flex-grow bg-white"
        onChange={event => setSearchTerm(event.target.value)}
        value={searchTerm}
        ref={ref}
        placeholder={searchInputPlaceholder}
        afterInput={
          !searchTerm && (
            <div className="pr-4 flex justiy-center items-center">
              <IconSearch size="5" className="fill-current text-slate-400" />
            </div>
          )
        }
      />
      <div className="flex h-12">
        <ScrollableTabs
          active={filter || 'all'}
          onClick={tab => onChangeFilter(tab)}
          tabs={tabs}
          scrollable
        />
      </div>
    </div>
  );
};

AddressBookTitleBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  onSearchTermChanged: PropTypes.func,
  buttons: PropTypes.node,
  onChangeFilter: PropTypes.func,
  filter: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  searchInputPlaceholder: PropTypes.string,
};

AddressBookTitleBar.defaultProps = {
  onSearchTermChanged: () => {},
  onChangeFilter: () => {},
  tabs: [],
  title: '',
  searchInputPlaceholder: '',
};

export default AddressBookTitleBar;
